import { fetchFamilyFeatures } from '@gn-audio/core/api/product-catalogue/fetch-family-features';
import { IFeature } from '@gn-audio/core/api/product-catalogue/models/feature';
import { Component, Input, OnChanges, SimpleChanges } from 'angular-ts-decorators';

import template from './customizer-features.component.html';

@Component({
  selector: 'customizerFeatures',
  template,
})
export class CustomizerFeaturesComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = ['$q'];

  @Input() public familyId?: number;
  @Input() public features: IFeature[] = [];

  constructor(private readonly $q: ng.IQService) { }

  public ngOnChanges(changes: SimpleChanges<CustomizerFeaturesComponent>) {
    if (!changes.familyId || !this.familyId) {
      return;
    }

    if (this.features?.length > 0) {
      return;
    }

    this.$q
      .when(fetchFamilyFeatures(this.familyId))
      .then((features: IFeature[]) => { this.features = features; });
  }
}
